import { connect } from 'react-redux';

import Report from './Report.js';
import { redux } from '../api';

const { setApplicationInfo, changeMenuTaskFn } = redux.actions;

const mapStateToProps = state => {
  return {
    user: state.api.user.ctInfo,
    reportTime: state.api.current.reportTime || [],
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApplicationData: data => {
      dispatch(setApplicationInfo(data));
    },
    changeMenuTaskData: data => {
      dispatch(changeMenuTaskFn(data));
    },
  };
};

const ConnectedReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(Report);

export default ConnectedReport;
